import React from 'react';
import styled from 'styled-components';
import Alert from './components/alert';

export const NurslingWarning = () => (
  <Component>
    <Alert />
  </Component>
);

const Component = styled.div`
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #cecccc;

  @media (min-width: 700px) {
    display: flex;
  }
`;

export default NurslingWarning;
